import { Box, BoxProps, Text, TextProps } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'
import { StackHeaderProps } from '@react-navigation/stack'
import { useCallback } from 'react'
import { View, ViewProps } from 'react-native'

export const Header = ({ navigation, options }: StackHeaderProps) => {
  const canGoBack = navigation.canGoBack()
  const onBackPress = useCallback(() => {
    if (canGoBack) {
      navigation?.goBack()
    } else {
      window.onBackPress()
    }
  }, [canGoBack, navigation])
  return (
    <View style={[styles.container, options.headerStyle]}>
      <Box {...styles.titleContainer}>
        <Text {...styles.titleStyle}>{options.headerTitle}</Text>
      </Box>

      <Box onPress={onBackPress} height={'100%'} underlayColor={'TRANSPARENT'} ph={10} justifyContent={'center'}>
        <Icon id={'ARROW_BACK'} color="WHITE" size={20} />
      </Box>
    </View>
  )
}

const styles = {
  container: {
    flexDirection: 'row',
    ph: 16,
    height: 48,
    backgroundColor: '#DF9F39',
    alignItems: 'center',
  } as ViewProps,
  titleStyle: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: 'WHITE',
  } as TextProps,
  titleContainer: {
    position: 'absolute',
    alignSelf: 'center',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
}
